import type { AlertValidationKey } from './alertValidator'

import { ApiError } from '@/shared/http'

export interface AlertSaveFieldError {
  field: 'compare_window'
  key: Extract<AlertValidationKey, 'alerts.validation.compareWindow'>
}

/** Maps the published alert validation envelope without exposing backend text or rejected values. */
export function alertSaveFieldError(cause: unknown): AlertSaveFieldError | null {
  const error = ApiError.isApiError(cause) ? cause : ApiError.fromAxios(cause)
  if (
    error.status !== 422 ||
    error.code !== 'ALERT_VALIDATION_FAILED' ||
    !Object.hasOwn(error.fields, 'compare_window')
  ) {
    return null
  }
  return { field: 'compare_window', key: 'alerts.validation.compareWindow' }
}
